import {
  TextInput,
  required,
  NumberInput,
  ReferenceInput,
  SelectInput,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  SelectArrayInput,
  AutocompleteInput,
} from "react-admin";
import { Grid } from "@mui/material";
import { administrationRequests } from "api/administrationApi";

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Име на английски език"
          source="nameEn"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={2}
      >
        <TextInput
          label="Етаж"
          source="floor"
          validate={[required()]}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={2}
      >
        <TextInput
          label="Номер"
          source="number"
          validate={[required()]}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <ReferenceInput
          source="typeId"
          reference={administrationRequests.getRoomTypesSelect()}
        >
          <SelectInput
            label="Тип"
            validate={[required()]}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <NumberInput
          label="Капацитет за лекции/упражнения"
          source="capacityClasses"
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={2}
      >
        <NumberInput
          label="Капацитет за изпит"
          source="capacityExam"
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceArrayInput
          source="disciplineIds"
          reference={administrationRequests.getDisciplinesSelect()}
          filter={{ filterByUser: true }}
        >
          <AutocompleteArrayInput
            optionText="name"
            label="Дисциплина"
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            fullWidth
          />
        </ReferenceArrayInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceArrayInput
          source="departmentIds"
          reference={administrationRequests.getDepartmentsSelect()}
        >
          <AutocompleteArrayInput
            optionText="name"
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            label="Катедри"
            fullWidth
          />
        </ReferenceArrayInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceArrayInput
          source="technicalEquipmentIds"
          reference={administrationRequests.getTechnicalEquipmentTypesSelect()}
          filter={{ OnlyWithoutRooms: true }}
        >
          <AutocompleteArrayInput
            optionText={record => (record ? `${record.name} - ${record.description || ""}` : "")}
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            label="Техническо оборудване"
            fullWidth
          />
        </ReferenceArrayInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceArrayInput
          source="classTypeIds"
          reference={administrationRequests.getRoomClassTypesSelect()}
        >
          <SelectArrayInput
            optionText="name"
            label="Тип занятия"
            fullWidth
          />
        </ReferenceArrayInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="buildingId"
          reference={administrationRequests.getBuildingsSelect()}
          label="Сграда"
        >
          <AutocompleteInput
            label="Сграда"
            optionText="name"
            optionValue="id"
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceArrayInput
          source="structuralUnitIds"
          reference={administrationRequests.getStructuralUnitsSelect()}
          filter={{ filterByUser: true }}
        >
          <SelectArrayInput
            optionText="name"
            label="Структурни единици"
            fullWidth
          />
        </ReferenceArrayInput>
      </Grid>
    </Grid>
  );
};
export default SaveForm;
